import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

var _AxisTicks;
var AxisTicks = withTheme((// eslint-disable-next-line zillow/react/prefer-stateless-function
_AxisTicks = /*#__PURE__*/function (_Component) {
  function AxisTicks() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(AxisTicks, _Component);
  var _proto = AxisTicks.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      orient = _this$props.orient,
      innerTickSize = _this$props.innerTickSize,
      tickPadding = _this$props.tickPadding,
      scale = _this$props.scale,
      tickValues = _this$props.tickValues,
      tickArguments = _this$props.tickArguments,
      tickFormatting = _this$props.tickFormatting,
      tickStroke = _this$props.tickStroke,
      tickTextStroke = _this$props.tickTextStroke;
    var tr;
    var ticks;
    var textAnchor;
    var tickFormat;
    var y1;
    var y2;
    var dy;
    var x1;
    var x2;
    var sign = orient === 'top' || orient === 'right' ? -1 : 1;
    var tickSpacing = Math.max(innerTickSize, 0) + tickPadding;
    if (tickValues) {
      ticks = tickValues;
    } else if (scale.ticks) {
      // eslint-disable-next-line prefer-spread
      ticks = scale.ticks.apply(scale, tickArguments);
    } else {
      ticks = scale.domain();
    }
    if (tickFormatting) {
      tickFormat = tickFormatting;
    } else if (scale.tickFormat) {
      // eslint-disable-next-line prefer-spread
      tickFormat = scale.tickFormat.apply(scale, tickArguments);
    } else {
      tickFormat = function tickFormat(d) {
        return d;
      };
    }
    var adjustedScale = scale.rangeBand ? function (d) {
      return scale(d) + scale.rangeBand() / 2;
    } : scale;

    // Still working on this
    // Ticks and lines are not fully aligned
    // in some orientations
    // eslint-disable-next-line default-case
    switch (orient) {
      case 'top':
        tr = function tr(tick) {
          return "translate(" + adjustedScale(tick) + ",0)";
        };
        textAnchor = 'middle';
        y2 = innerTickSize * sign;
        y1 = tickSpacing * sign;
        dy = sign < 0 ? '0em' : '.71em';
        break;
      case 'bottom':
        tr = function tr(tick) {
          return "translate(" + adjustedScale(tick) + ",0)";
        };
        textAnchor = 'middle';
        y2 = innerTickSize * sign;
        y1 = tickSpacing * sign;
        dy = sign < 0 ? '0em' : '.71em';
        break;
      case 'left':
        tr = function tr(tick) {
          return "translate(0," + adjustedScale(tick) + ")";
        };
        textAnchor = 'end';
        x2 = innerTickSize * -sign;
        x1 = tickSpacing * -sign;
        dy = '.32em';
        break;
      case 'right':
        tr = function tr(tick) {
          return "translate(0," + adjustedScale(tick) + ")";
        };
        textAnchor = 'start';
        x2 = innerTickSize * -sign;
        x1 = tickSpacing * -sign;
        dy = '.32em';
        break;
    }
    return /*#__PURE__*/React.createElement("g", null, ticks.map(function (tick, idx) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line zillow/react/no-array-index-key
        React.createElement("g", {
          key: idx,
          className: "tick",
          transform: tr(tick)
        }, /*#__PURE__*/React.createElement("line", {
          style: {
            shapeRendering: 'crispEdges',
            opacity: '1',
            stroke: tickStroke
          },
          x2: x2,
          y2: y2
        }), /*#__PURE__*/React.createElement("text", {
          strokeWidth: "0.01",
          dy: dy,
          x: x1,
          y: y1,
          style: {
            stroke: tickTextStroke,
            fill: tickTextStroke
          },
          textAnchor: textAnchor
        }, tickFormat(tick)))
      );
    }));
  };
  return AxisTicks;
}(Component), _AxisTicks.displayName = 'AxisTicks', _AxisTicks.propTypes = {
  scale: PropTypes.func.isRequired,
  orient: PropTypes.oneOf(['top', 'bottom', 'left', 'right']).isRequired,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tickArguments: PropTypes.array,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tickValues: PropTypes.array,
  innerTickSize: PropTypes.number,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  outerTickSize: PropTypes.number,
  tickPadding: PropTypes.number,
  tickFormat: PropTypes.func,
  tickStroke: PropTypes.string,
  tickTextStroke: PropTypes.string,
  // To simply satisfy eslint
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tickFormatting: PropTypes.any
}, _AxisTicks.defaultProps = {
  innerTickSize: 6,
  outerTickSize: 6,
  tickPadding: 3,
  tickArguments: [10],
  tickValues: null
}, _AxisTicks));
var AxisTicks$1 = AxisTicks;

export { AxisTicks$1 as default };
